import React from 'react';
import { Box, Typography, Container, Grid, Paper } from '@mui/material';
import { Eye, Target } from 'lucide-react';
import { images } from '../assets/images';
import { gradients } from '../theme';
import FadeIn from './FadeIn';

const VisionMission: React.FC = () => {
  return (
    <Box
      sx={{
        backgroundColor: 'black',
        py: 15,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Background Glow */}
      <Box
        sx={{
          position: 'absolute',
          top: '20%',
          right: '-10%',
          width: '60%',
          height: '60%',
          background: 'radial-gradient(circle, rgba(0, 242, 255, 0.04) 0%, transparent 70%)',
          borderRadius: '50%',
          filter: 'blur(100px)',
          zIndex: 0,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: '10%',
          left: '-10%',
          width: '50%',
          height: '50%',
          background: 'radial-gradient(circle, rgba(33, 150, 243, 0.04) 0%, transparent 70%)',
          borderRadius: '50%',
          filter: 'blur(100px)',
          zIndex: 0,
        }}
      />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>

        {/* --- Vision Section --- */}
        <Grid container spacing={6} alignItems="center" sx={{ mb: 12 }}>
          {/* Text */}
          <Grid size={{ xs: 12, md: 6 }}>
            <FadeIn direction="right">
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
                <Box sx={{ display: 'flex', color: '#00f2ff' }}>
                  <Eye size={24} />
                </Box>
                <Typography variant="overline" sx={{ color: '#00f2ff', fontWeight: 700, letterSpacing: 2, lineHeight: 1, pt: 0.5 }}>
                  OUR VISION
                </Typography>
              </Box>
              <Typography
                variant="h2"
                sx={{
                  ...gradients.primaryText,
                  mb: 3,
                  fontWeight: 700,
                }}
              >
                Leading the Way in Recycling
              </Typography>
              <Typography sx={{ color: 'grey.400', fontSize: '1.25rem', lineHeight: 1.6 }}>
                To become the UAE's most trusted catalytic-converter recycling and precious-metal recovery partner, setting new standards for sustainability and efficiency.
              </Typography>
            </FadeIn>
          </Grid>

          {/* Image Collage */}
          <Grid size={{ xs: 12, md: 6 }}>
            <FadeIn direction="left">
              <Box sx={{ position: 'relative', width: '100%', maxWidth: 500, height: 400, mx: 'auto' }}>
                <Box
                  component="img"
                  src={images.visionImage4}
                  sx={{ position: 'absolute', top: 0, left: 0, width: '60%', height: '45%', borderRadius: '12px', objectFit: 'cover' }}
                />
                <Box
                  component="img"
                  src={images.visionImage3}
                  sx={{ position: 'absolute', top: 0, right: 0, width: '35%', height: '45%', borderRadius: '12px', objectFit: 'cover' }}
                />
                <Box
                  component="img"
                  src={images.visionImage1}
                  sx={{ position: 'absolute', bottom: 0, left: 0, width: '48%', height: '50%', borderRadius: '12px', objectFit: 'cover' }}
                />
                <Box
                  component="img"
                  src={images.visionImage2}
                  sx={{ position: 'absolute', bottom: 0, right: 0, width: '48%', height: '50%', borderRadius: '12px', objectFit: 'cover' }}
                />
              </Box>
            </FadeIn>
          </Grid>
        </Grid>

        {/* --- Mission Section --- */}
        <Grid container spacing={8} alignItems="center" direction={{ xs: 'column-reverse', md: 'row' }}>
          {/* Image */}
          <Grid size={{ xs: 12, md: 6 }}>
            <FadeIn direction="right">
              <Box
                component="img"
                src={images.missionImage}
                sx={{
                  width: '100%',
                  borderRadius: '24px',
                  objectFit: 'cover',
                  boxShadow: '0 20px 40px -10px rgba(0,0,0,0.5)',
                }}
              />
            </FadeIn>
          </Grid>

          {/* Text */}
          <Grid size={{ xs: 12, md: 6 }}>
            <FadeIn direction="left">
              <Box sx={{ pl: { md: 4 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
                  <Box sx={{ display: 'flex', color: '#00f2ff' }}>
                    <Target size={24} />
                  </Box>
                  <Typography variant="overline" sx={{ color: '#00f2ff', fontWeight: 700, letterSpacing: 2, lineHeight: 1, pt: 0.5 }}>
                    OUR MISSION
                  </Typography>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    ...gradients.primaryText,
                    mb: 3,
                    fontWeight: 700,
                  }}
                >
                  Value, Transparency, & Innovation
                </Typography>
                <Typography sx={{ color: 'grey.400', fontSize: '1.25rem', lineHeight: 1.6 }}>
                  To extract maximum value from used catalytic converters through accurate metal analysis, transparent pricing, and responsible refining, serving our partners with integrity.
                </Typography>
              </Box>
            </FadeIn>
          </Grid>
        </Grid>

      </Container>
    </Box>
  );
};

export default VisionMission;
